import {FormControl} from 'platform/components';

import {RefObject} from 'react';

import {GeneralSettingsFormValues} from '../types/GeneralSettingsFormValues';

interface RegisterFormSubmitProps {
  control: FormControl<GeneralSettingsFormValues>;
  formSubmitRef: RefObject<(() => Promise<boolean>) | null>;
}

// Bridges the general settings form's submit into GeneratedDescriptionsContext so the
// platform detail action (a sibling subtree) can trigger a full form save. Renders nothing.
// The closure is refreshed on every render so it always targets the current submit handler.
export function RegisterFormSubmit(props: RegisterFormSubmitProps) {
  props.formSubmitRef.current = () => props.control.submitForm();
  return null;
}
